import { Box, BoxProps, Flex } from "@chakra-ui/react";
import { defaultTransition } from "chakra/theme";
import Navbar, { NavbarProps, navbarWidth } from "components/navbar";
import SideMenu from "components/side-menu";
import { PageTitle } from "components/title-with-back-button";
import { ReactNode } from "react";

export const pageContentPadding = "30px";

export function GetLayout({
  children,
  HeadRender,
  pageContentProps,
  withOutLayout,
  title,
  rightContent,
  pageTitleProps
}: {
  children?: ReactNode;
  HeadRender?: NavbarProps["HeadRender"];
  pageContentProps?: BoxProps;
  withOutLayout?: boolean;
  title?: string;
  rightContent?: ReactNode;
  pageTitleProps?: Partial<React.ComponentProps<typeof PageTitle>>;
}) {
  // const router = useRouter();
  // const exceptions = [
  //   "/atendimento-cliente-page",
  //   "/atendimentos",
  //   "/confirm-licenses"
  // ].includes(router.pathname);

  // const isPendingPayment = true;

  if (withOutLayout) return <>{children}</>;

  return (
    <>
      <Navbar HeadRender={HeadRender} />
      <Flex w="100%" h={`calc(100vh - ${navbarWidth})`} bg="bg-gray">
        <SideMenu />
        <Box
          id="page-content"
          outline="none"
          maxW={{ base: "calc(100% - 100px)" }}
          w="100%"
          p={{ base: "30px", xl: "30px 30px 30px 30px" }}
          maxH={`calc(100vh - ${navbarWidth})`}
          overflow="auto"
          transition={defaultTransition}
          display={"block"}
          bg={`#F5F7F9`}
          css={{ scrollbarGutter: "stable" }}
          {...pageContentProps}
        >
          {title ? (
            <Flex mb="30px" alignItems="center" justifyContent="space-between">
              <PageTitle title={title} {...pageTitleProps} />
              {rightContent && <Flex gap="8px">{rightContent}</Flex>}
            </Flex>
          ) : null}
          {/* {isPendingPayment && !exceptions && <PaymentPendingCard />} */}
          {children}
        </Box>
      </Flex>
    </>
  );
}
